import React from 'react';
import './SuspenseOverlay.scss';

function SuspenseOverlay() {
	return (
		<div style={{ minHeight: '100vh' }}>
			<div className='pageLoadingOverlay'>
				<div className='pageLoadingOverlayContent'>
					<div className='spinner-border text-primary' role='status'>
						<span className='visually-hidden'></span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default SuspenseOverlay;
